<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-toggle>
        <ion-button>
          <ion-icon slot="icon-only" name="menu"></ion-icon>
        </ion-button>
      </ion-menu-toggle>
      <ion-back-button text=""></ion-back-button>
    </ion-buttons>
    <ion-title>{{'MODALS.CONFIRM.'+action+'.ACCESSDEVICE.TITLE' | uppercase |translate}}</ion-title>
  </ion-toolbar>
</ion-header>

<div class="inner-content">
  <ion-grid>

    <ion-list>
      <ion-item *ngFor="let access of accesses">
        <ion-avatar slot="start">
          <img src="https://ionicframework.com/docs/demos/api/avatar/avatar.svg" name="person" />
        </ion-avatar>
        <ion-label>
          <h3>
            {{ access.properties.name | titlecase}}
          </h3>
          <p *ngIf="access.properties.keyCardNumber">
            {{access.properties.keyCardNumber}}
          </p>
          <p *ngIf="access.properties.email">
            {{access.properties.email}}
          </p>
        </ion-label>
      </ion-item>
      <!-- </ion-card> -->
    </ion-list>
    <ion-row size-lg="12"></ion-row>


    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <ion-col size="5">
          <ion-button (click)="dismissModal(true)">{{'MODALS.DELETE.CANCEL' |translate}}</ion-button>
        </ion-col>
        <ion-col size="2">
        </ion-col>
        <ion-col size="5">
          <ion-button (click)="submit()">
            <ion-label>
              <span *ngIf="!subBtnClicked">{{'MODALS.DELETE.BUTTON' |translate}}</span>
              <span *ngIf="subBtnClicked">
                &nbsp;&nbsp;&nbsp;&nbsp;
                <ion-spinner></ion-spinner>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </ion-label>
          </ion-button>
        </ion-col>
      </ion-col>
    </ion-row>
  </ion-grid>




</div>